import { globalBackendClient as backendClient } from '@mimir/client-common/globals/backendClient';
import type { CreateArchiveLocationDto, DeleteArchiveLocationDto, UpdateArchiveLocationDto } from '@mimir/common/dto/archiveLocationDto';
import { api_createTenantConfigArchiveLocation, api_deleteTenantConfigArchiveLocation, api_deleteTenantConfigDefaultArchiveLocation, api_getTenantConfigArchiveLocations, api_getTenantConfigDefaultArchiveLocation, api_updateTenantConfigArchiveLocation } from '@mimir/client-common/api/archiveLocationApi';

export const getTenantConfigArchiveLocations = async () =>
  api_getTenantConfigArchiveLocations(backendClient);

export const updateTenantConfigArchiveLocation = async (archiveLocation: UpdateArchiveLocationDto) =>
  api_updateTenantConfigArchiveLocation(backendClient, archiveLocation);

export const deleteTenantConfigArchiveLocation = async (archiveLocation: DeleteArchiveLocationDto) =>
  api_deleteTenantConfigArchiveLocation(backendClient, archiveLocation);

export const createTenantConfigArchiveLocation = async (archiveLocation: CreateArchiveLocationDto) =>
  api_createTenantConfigArchiveLocation(backendClient, archiveLocation);

export const getTenantConfigDefaultArchiveLocation = async () =>
  api_getTenantConfigDefaultArchiveLocation(backendClient);

export const deleteTenantConfigDefaultArchiveLocation = async () =>
  api_deleteTenantConfigDefaultArchiveLocation(backendClient);

